import {PostFavoriteDoctorRequest} from 'domain/usecases';
import {makePostFavoriteDoctor} from 'main/factories/usecases';

export async function postFavoriteDoctor({
	cdEspecialidade,
	cdPrestador,
	cdSubEspecialidade,
	signal,
}: PostFavoriteDoctorRequest) {
	await makePostFavoriteDoctor().post({cdEspecialidade, cdSubEspecialidade, cdPrestador, signal});
}
